<div class="calendar-month-toggle">
  <button
    mat-flat-button
    class="month-button"
    (click)="monthIndexSelected.emit(calendarIndex - 1)"
  >
    <p
      class="month-text"
      [ngClass]="calendarIndex == 0 ? 'disabled-text' : 'link-text'"
    >
      Previous
    </p>
  </button>
  <button
    mat-flat-button
    class="month-button"
    (click)="monthSelected.emit(selectedMonth)"
  >
    <p
      class="month-text"
    >
      {{selectedMonth}}
    </p>
  </button>
  <button
    mat-flat-button
    class="month-button"
    (click)="monthIndexSelected.emit(calendarIndex + 1)"
  >
    <p
      class="month-text"
      [ngClass]="calendarIndex == data.length - 1 ? 'disabled-text' : 'link-text'"
    >
      Next
    </p>
  </button>
</div>
